<script setup>
import AuthenticationCard from "@/Components/AuthenticationCard.vue";
import AuthenticationCardLogo from "@/Components/AuthenticationCardLogo.vue";
import FloatingBee from "@/Components/FloatingBee.vue";

import Button from "primevue/button";

const getThemeFromLocalStorage = () => {
  const theme = localStorage.getItem("theme");
  if (theme) {
    if (
      theme === "dark" &&
      !document.documentElement.classList.contains("dark")
    )
      toggleDarkMode();
    else if (
      theme === "light" &&
      document.documentElement.classList.contains("dark")
    )
      toggleDarkMode();
  }
};

const toggleDarkMode = () => {
  document.documentElement.classList.toggle("dark");

  // Optionally, you can store the user's preference in localStorage
  if (document.documentElement.classList.contains("dark"))
    localStorage.setItem("theme", "dark");
  else localStorage.setItem("theme", "light");
};

getThemeFromLocalStorage();
</script>

<template>
  <div class="auth-layout">
    <div style="height: 0; color: transparent">Don't know why I need this.</div>
    <FloatingBee left />
    <div class="dark-mode-toggle-container">
      <Button
        class="toggle-to-light"
        icon="pi pi-sun"
        severity="secondary"
        @click="toggleDarkMode()"
      />
      <Button
        class="toggle-to-dark"
        icon="pi pi-moon"
        severity="secondary"
        @click="toggleDarkMode()"
      />
    </div>

    <AuthenticationCard class="wrapper">
      <template #logo>
        <AuthenticationCardLogo />
      </template>

      <div class="auth-card">
        <slot />
      </div>
    </AuthenticationCard>
  </div>
</template>

<style lang="scss" scoped>
html.dark {
  .toggle-to-dark {
    display: none;
  }
}

html:not(.dark) {
  .toggle-to-light {
    display: none;
  }
}

.dark-mode-toggle-container {
  position: fixed;
  top: 1rem;
  right: 1rem;
  display: flex;
  gap: 0.5rem;
}

.wrapper {
  padding: 4rem;
}
</style>
